<template>
  <div class="center">
    <!-- 返回按键 -->
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>

    <!-- 条件筛选框 -->
    <div class="waitingcom_title">
      <!-- 表单 -->
      <el-form
        :model="formLabelAlign"
        ref="formLabelAlign"
        label-width="80px"
        :label-position="labelPosition"
      >
        <el-form-item label="考生姓名：">
          <el-input
            v-model.trim="formLabelAlign.realName"
            placeholder="请输入考生姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="考生账号：">
          <el-input
            v-model.trim="formLabelAlign.userName"
            placeholder="请输入考生账号"
          ></el-input>
        </el-form-item>

        <el-form-item label="职称：">
          <el-select
            v-model="formLabelAlign.pTitle"
            placeholder="全部"
            @change="handleQuery"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in pTitleList"
              :key="item.PTitle"
              :label="item.PTitle"
              :value="item.PTitle"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职位：">
          <el-select
            v-model="formLabelAlign.position"
            placeholder="全部"
            @change="handleQuery"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in positionList"
              :key="item.Position"
              :label="item.Position"
              :value="item.Position"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 搜索按钮 -->
      <div class="query_btn">
        <el-button
          @click="handleQuery"
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          >搜索</el-button
        >
        <el-button
          @click="resetQuery"
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 列表全局按钮 -->
    <div class="oper_box">
      <el-button @click="addMember" plain
        ><i class="iconfont icon-action-add-hover"></i>添加考生</el-button
      >
      <el-button @click="batchDeleteInit" plain
        ><i class="iconfont icon-yichu"></i>批量移除</el-button
      >
    </div>

    <!-- 表格内容 -->
    <div class="content_table">
      <div class="content_title">
        <span>科室名称：</span
        ><span>{{ this.$parent.$children[0].rowData.DepartmentName }}</span>
      </div>
      <el-table
        ref="table"
        :data="getData"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        @row-click="stepsListRowClick"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
        v-loading="isLoading"
      >
        <el-table-column
          type="selection"
          width="60"
          align="center"
          :reserve-selection="true"
        ></el-table-column>

        <el-table-column label="序号" type="index" width="60" align="center"
          ><template slot-scope="scope">
            <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="考生账号" align="center">
          <template slot-scope="scope">
            {{ scope.row.UserName }}
          </template>
        </el-table-column>

        <el-table-column label="考生姓名" align="center">
          <template slot-scope="scope">
            {{ scope.row.RealName }}
          </template>
        </el-table-column>

        <el-table-column label="职称" align="center">
          <template slot-scope="scope">
            {{ scope.row.PTitle }}
          </template>
        </el-table-column>

        <el-table-column label="职位" align="center">
          <template slot-scope="scope">
            {{ scope.row.Position }}
          </template>
        </el-table-column>

        <el-table-column label="出生年月" align="center">
          <template slot-scope="scope">
            {{
              scope.row.Birthday == null
                ? null
                : $moment(scope.row.Birthday).format("YYYY-MM-DD")
            }}
          </template>
        </el-table-column>

        <el-table-column label="工作年限" align="center">
          <template slot-scope="scope">
            {{ scope.row.JobDateStr }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="250">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                @click.stop="
                  pageVisible = true;
                  pageForm = JSON.parse(JSON.stringify(scope.row));
                "
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="
                  hintDialogVisible = true;
                  isDetele = true;
                  hintDialogTitle = '移除考生';
                  hintDialogContent =
                    '确定将名为 ' +
                    scope.row.RealName +
                    ' 的考生移除吗？移除后不可还原';
                  rowData = scope.row;
                "
                >移除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :page-sizes="pagesizesArr"
          layout="prev, pager, next, sizes, jumper"
          :total="total"
          class="pagination"
        ></el-pagination>
      </div>
    </div>

    <!-- 提示弹窗 -->
    <div class="hintDialogBox">
      <el-dialog
        :title="hintDialogTitle"
        :visible.sync="hintDialogVisible"
        width="30%"
        @close="hintDialogClose"
      >
        <span>{{ hintDialogContent }}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="hintDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="hintDialogSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 添加考生 -->
    <!-- <AddMember ref="addMember" /> -->
    <Addstudent
      ref="addstudent"
      @finallyArr="getfinallyArr"
      :departmentID="departmentID"
      :types="types"
    />
    <!-- 编辑考生 -->
    <div class="dialogBox">
      <el-dialog
        title="编辑考生"
        :visible.sync="pageVisible"
        width="30%"
        @close="pageClose"
      >
        <el-form
          :model="pageForm"
          ref="pageForm"
          :rules="pageRules"
          label-width="80px"
          :label-position="pageLabelPosition"
        >
          <el-form-item label="考生ID：" style="display: none">
            <el-input
              v-model.trim="pageForm.UserID"
              placeholder="请输入考生ID"
            ></el-input>
          </el-form-item>

          <el-form-item label="考生账号：" prop="UserName">
            <el-input
              v-model.trim="pageForm.UserName"
              :disabled="true"
            ></el-input>
          </el-form-item>

          <el-form-item label="考生姓名：" prop="RealName">
            <el-input
              v-model.trim="pageForm.RealName"
              placeholder="请输入考生姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="科室：" style="display: none">
            <el-input
              v-model.trim="pageForm.DepartmentName"
              placeholder="请输入科室"
            ></el-input>
          </el-form-item>

          <el-form-item label="职称：">
            <el-select v-model="pageForm.PTitle" placeholder="全部">
              <el-option
                v-for="item in pTitleList"
                :key="item.PTitle"
                :label="item.PTitle"
                :value="item.PTitle"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="职位：">
            <el-select v-model="pageForm.Position" placeholder="全部">
              <el-option
                v-for="item in positionList"
                :key="item.Position"
                :label="item.Position"
                :value="item.Position"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="出生年月：">
            <el-date-picker
              v-model="pageForm.Birthday"
              type="date"
              placeholder="选择日期时间"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="入职日期：">
            <el-date-picker
              v-model="pageForm.JobDate"
              type="date"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="pageVisible = false">取 消</el-button>
          <el-button type="primary" @click="editStudent">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import departApi from "@/api/depart";
// import AddMember from "../components/AddMember.vue";
import Addstudent from "@/components/addCandidate/Addstudent.vue";
export default {
  props: ["changes"],
  components: {
    Addstudent,
  },
  data() {
    // 校验非空
    var validateIsNull = (rule, value, callback, prefixMsg) => {
      if (value instanceof Array) {
        value = value.join("");
      }
      if (value.split(" ").join("").length === 0) {
        callback(new Error(prefixMsg + "不能为空"));
      } else {
        callback();
      }
    };
    return {
      // 条件筛选框全局定义
      labelPosition: "right",
      formLabelAlign: {
        realName: "",
        userName: "",
        pTitle: "",
        position: "",
      },
      types: 0,
      pTitleList: [],
      positionList: [],
      // 列表全局按钮定义
      multiple: true,
      // 提示弹窗唤起
      hintDialogVisible: false,
      hintDialogTitle: "",
      hintDialogContent: "",
      isDetele: false,
      isBatchDelete: false,
      // 编辑全局定义
      pageVisible: false,
      pageLabelPosition: "left",
      pageForm: {
        UserID: "",
        UserName: "",
        RealName: "",
        DepartmentName: "",
        PTitle: "",
        Position: "",
        Birthday: "",
        JobDate: "",
      },
      pageRules: {
        UserName: [
          { required: true, message: "请输入考生账号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "考生账号");
            },
            trigger: "blur",
          },
        ],
        RealName: [
          { required: true, message: "请输入考生姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              validateIsNull(rule, value, callback, "考生姓名");
            },
            trigger: "blur",
          },
        ],
      },
      pickerOptions: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
      // 选中行数据
      rowData: {},
      // 表格内容全局定义
      isLoading: true,
      multipleSelectionIds: [],
      multipleSelection: [],
      multipleSelectionCount: 0,
      getDataCondition: {
        realName: "",
        userName: "",
        pTitle: "",
        position: "",
      },
      departmentID: "",
      getData: [],
      currentPage: 1,
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 0,
    };
  },
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.changes(0);
    },
    // 搜索
    handleQuery() {
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      if (this.formLabelAlign.realName) {
        this.getDataCondition.realName = this.formLabelAlign.realName;
      } else {
        this.getDataCondition.realName = "";
      }
      if (this.formLabelAlign.userName) {
        this.getDataCondition.userName = this.formLabelAlign.userName;
      } else {
        this.getDataCondition.userName = "";
      }
      if (this.formLabelAlign.pTitle) {
        this.getDataCondition.pTitle = this.formLabelAlign.pTitle;
      } else {
        this.getDataCondition.pTitle = "";
      }
      if (this.formLabelAlign.position) {
        this.getDataCondition.position = this.formLabelAlign.position;
      } else {
        this.getDataCondition.position = "";
      }
      this.getDeptStudentLists();
    },
    // 确定考生名单
    getfinallyArr(row) {
      this.getData = row;
    },
    // 重置
    resetQuery() {
      this.formLabelAlign = {
        realName: "",
        userName: "",
        pTitle: "",
        position: "",
      };
      this.$refs.table.clearSelection();
      this.currentPage = 1;
      this.getDataCondition.realName = "";
      this.getDataCondition.userName = "";
      this.getDataCondition.pTitle = "";
      this.getDataCondition.position = "";
      this.getDeptStudentLists();
    },
    // 基本请求参数工具
    baseReqParamUtils(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },
    // 获取条件筛选框职称下拉列表
    async getPTitleLists() {
      const reqParam = this.baseReqParamUtils(new Object());
      console.log(reqParam, "获取职称下拉列表请求数据");
      const { data } = await departApi.getPTitleList(reqParam);
      console.log(data, "获取职称下拉列表请求数据");
      if (data.Status == 200) {
        this.pTitleList = data.Data;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 获取条件筛选框职位下拉列表
    async getPositionLists() {
      const reqParam = this.baseReqParamUtils(new Object());
      console.log(reqParam, "获取职位下拉列表请求数据");
      const { data } = await departApi.getPositionList(reqParam);
      console.log(data, "获取职位下拉列表请求数据");
      if (data.Status == 200) {
        this.positionList = data.Data;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 获取科室考生列表
    async getDeptStudentLists() {
      this.isLoading = true;
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.pageIndex = this.currentPage - 1;
      reqParam.eachPageNum = this.pageSize;
      reqParam.dertID = this.$parent.$children[0].rowData.departmentID;
      this.departmentID = reqParam.dertID;
      reqParam.hidID = reqParam.hid;
      reqParam.realName = this.getDataCondition.realName;
      reqParam.userName = this.getDataCondition.userName;
      reqParam.pTitle = this.getDataCondition.pTitle;
      reqParam.position = this.getDataCondition.position;
      const { data } = await departApi.getDeptStudentList(reqParam);
      if (data.Status == 200) {
        this.getData = data.Data.data;
        this.total = data.Data.count;
        this.isLoading = false;
      } else {
        this.$message.error(data.Data);
      }
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 表格多选框改变时触发
    handleSelectionChange(rows) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = [];
      this.multipleSelection = [];
      this.multipleSelectionCount = 0;
      // 将数据存入
      rows.forEach((row) => {
        this.multipleSelectionIds.push(row.UserID);
      });
      this.multipleSelection = rows;
      this.multipleSelectionCount = this.multipleSelection.length;
      // 全局按钮样式配置
      this.multiple = !this.multipleSelection.length;
    },
    // 勾选当前行激活check
    stepsListRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.UserID;
    },
    // 每页大小改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getDeptStudentLists();
    },
    // 切换页数后触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getDeptStudentLists();
    },
    // 批量移除初始化
    batchDeleteInit() {
      if (this.multipleSelection.length < 1) {
        this.$message.warning("请选择要移除的考生");
        return;
      }
      this.hintDialogVisible = true;
      this.isBatchDelete = true;
      this.hintDialogTitle = "批量移除考生";
      this.hintDialogContent = "确定要将选定考生批量移除吗？移除后不可还原";
    },
    // 提示弹窗关闭触发
    hintDialogClose() {
      this.isDetele = false;
      this.isBatchDelete = false;
    },
    // 提示弹窗提交按钮
    async hintDialogSubmit() {
      // 移除考生
      if (this.isDetele) {
        console.log("移除考生...");
        const reqParam = this.baseReqParamUtils(new Object());
        reqParam.studentUserID = this.rowData.UserID;
        console.log(reqParam, "移除考生请求数据");
        const { data } = await departApi.deleteStudent(reqParam);
        console.log(data, "移除考生返回数据");
        if (data.Status == 200) {
          this.hintDialogVisible = false;
          this.$message.success("移除考生成功");
          this.getDeptStudentLists();
          // this.$refs.addMember.getStudentLists();
        } else {
          this.$message.error(data.Data);
        }
      }

      // 批量移除考生
      if (this.isBatchDelete) {
        console.log("批量移除考生...");
        const reqParam = this.baseReqParamUtils(new Object());
        reqParam.studentUserIDArr = `[${this.multipleSelectionIds}]`;
        console.log(reqParam, "批量移除考生请求数据");
        const { data } = await departApi.deleteStudentBatch(reqParam);
        console.log(data, "批量移除考生返回数据");
        if (data.Status == 200) {
          this.hintDialogVisible = false;
          this.$message.success("批量移除考生成功");
          this.getDeptStudentLists();
          this.$refs.table.clearSelection();
          // this.$refs.addMember.getStudentLists();
        } else {
          this.$message.error(data.Data);
        }
      }
    },
    // 吊起添加考生子组件
    addMember() {
      this.$refs.addstudent.init(this.getData);
      // this.$refs.addMember.addMemberVisible = true;
    },
    // 编辑考生关闭触发
    pageClose() {
      this.$refs.pageForm.resetFields();
      this.pageForm.UserID = "";
      this.pageForm.UserName = "";
      this.pageForm.RealName = "";
      this.pageForm.DepartmentName = "";
      this.pageForm.PTitle = "";
      this.pageForm.Position = "";
      this.pageForm.Birthday = "";
      this.pageForm.JobDate = "";
    },
    // 编辑考生
    editStudent() {
      this.$refs.pageForm.validate((valid) => {
        if (valid) {
          this.modifyStudentInfos();
        } else {
          return false;
        }
      });
    },
    // 编辑考生
    async modifyStudentInfos() {
      const reqParam = this.baseReqParamUtils(new Object());
      reqParam.UpdataID = this.pageForm.UserID;
      reqParam.realName = this.pageForm.RealName;
      reqParam.departmentName = this.pageForm.DepartmentName;
      reqParam.PTitle = this.pageForm.PTitle;
      reqParam.Position = this.pageForm.Position;
      if (this.pageForm.Birthday != null) {
        reqParam.Birthday = this.$moment(this.pageForm.Birthday).format(
          "YYYY-MM-DD"
        );
      }
      if (this.pageForm.JobDate != null) {
        reqParam.JobDate = this.$moment(this.pageForm.JobDate).format(
          "YYYY-MM-DD"
        );
      }
      console.log(reqParam, "编辑考生请求数据");
      const { data } = await departApi.modifyStudentInfo(reqParam);
      console.log(data, "编辑考生返回数据");
      if (data.Status == 200) {
        this.$message.success("编辑考生成功");
        this.pageVisible = false;
        this.getDeptStudentLists();
      } else {
        this.$message.error(data.Data);
      }
    },
  },
  created() {
    this.getPTitleLists();
    this.getPositionLists();
    this.getDeptStudentLists();
  },
};
</script>

<style lang="scss" scoped>
// 右边整体iframe的css
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}

// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

// 条件筛选框css
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .el-form {
    display: flex;
    ::v-deep .el-form-item__content {
      margin-left: 115px !important;
    }
    ::v-deep .el-input > .el-input__inner {
      width: 168px;
    }
  }
  .query_btn {
    margin: 0;
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
    }
  }
}

// 列表全局按钮css
.oper_box {
  display: flex;
  margin: 14px 0px 20px 0px;
  width: 88px;
  height: 40px;
  opacity: 1;
  padding: 0px 24px !important;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    letter-spacing: 1px;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    background: #1890ff;
    width: 104px;
    margin-left: 0px;
    margin-right: 24px;
  }
  .el-button:nth-child(2) {
    background: #e54d4d;
    width: 136px;
    margin-left: 0px;
    margin-right: 24px;
    span > i {
      font-size: 16px !important;
      margin-right: 5px;
    }
  }
}

// 表格内容css
.content_table {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
}

.content_title {
  height: 52px;
  background: #eef7ff;
  opacity: 1;
  border-radius: 10px 10px 0px 0px;
  padding-left: 22px;
  span {
    width: 144px;
    height: 52px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 52px;
    color: #333333;
    opacity: 1;
  }
}

.operation_box {
  width: 250px;
  text-align: center;
  margin: 0 auto;
  .el-button {
    font-size: 16px;
    margin-left: 0px;
    margin-right: 25px;
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}

// 分页
.foot_box {
  position: relative;
  height: 88px;
  .foot_pagetions {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
    .pagination {
      ::v-deep .el-pager {
        li {
          border: 1px solid #d9d9d9;
          margin-right: 8px;
          &.active {
            color: #ffffff;
            background-color: #409eff;
            border: none;
          }
        }
      }
      ::v-deep .el-pagination__jump {
        margin: 0px 10px 0px 0px !important;
      }
    }
  }
}

// dialog弹窗css
.dialogBox {
  // dialog整体样式
  ::v-deep .el-dialog {
    width: 537px;
    height: 633px;
    border-radius: 5px 5px 5px 5px;
    background: #ffffff;
    opacity: 1;
    // 弹框头部样式
    .el-dialog__header {
      height: 60px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    // 弹框身体样式
    .el-dialog__body {
      padding-top: 35px;
      padding-bottom: 10px;
      .el-form {
        display: flex;
        flex-direction: column;
        .el-form-item {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
          .el-form-item__label {
            width: 98px !important;
            height: 40px;
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 40px;
            color: #333333;
            opacity: 1;
          }
          .el-form-item__content {
            margin-left: 0px !important;
            .el-input__inner {
              width: 380px;
              height: 40px;
              background: #ffffff;
              border: 1px solid #d9d9d9;
              opacity: 1;
              border-radius: 4px;
            }
            .el-input {
              width: 100%;
            }
          }
        }
      }
    }
    // 弹框底部样式
    .dialog-footer {
      text-align: center;
      .el-button {
        margin-right: 50px;
      }
      .el-button:nth-child(1) {
        background: #eeeeee;
        opacity: 1;
        border-radius: 4px;
      }
      .el-button:nth-child(2) {
        background: #1890ff;
        opacity: 1;
        border-radius: 4px;
      }
    }
  }
}

// dialog提示弹窗css
.hintDialogBox {
  // dialog整体样式
  ::v-deep .el-dialog {
    width: 421px !important;
    height: 211px;
    border-radius: 5px 5px 5px 5px;
    background: #ffffff;
    opacity: 1;
    // 弹框头部样式
    .el-dialog__header {
      height: 60px;
      background: linear-gradient(
        180deg,
        #64b5ff 0%,
        rgba(199, 228, 255, 1) 100%
      );
      opacity: 1;
      border-radius: 5px 5px 0px 0px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    // 弹框身体样式
    .el-dialog__body {
      text-align: center;
    }
    // 弹框底部样式
    .dialog-footer {
      text-align: center;
      .el-button {
        margin-right: 50px;
      }
      .el-button:nth-child(1) {
        background: #eeeeee;
        opacity: 1;
        border-radius: 4px;
      }
      .el-button:nth-child(2) {
        background: #1890ff;
        opacity: 1;
        border-radius: 4px;
      }
    }
  }
}
</style>